// extracted by mini-css-extract-plugin
export default {"fillLink":"styles_fillLink__Q53Bu","link":"styles_link__rkZx9"};